import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "asin-image-content"
};
const _hoisted_2 = {
  class: ""
};
const _hoisted_3 = {
  class: "label"
};
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useLess } from '@/models/hooks';
export default {
  __name: 'OutOfStockPopup',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    asinList: {
      type: Object
    }
  },
  emits: ['update:show', 'confirm'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/cart/components/OutOfStockPopup.less');
    const {
      t
    } = useI18n();
    const isShowVal = computed({
      get: () => props.isShow,
      set: val => {
        emit('update:isShow', val);
      }
    });
    const productStatusText = selectionEligible => {
      if (!selectionEligible) {
        return t('common.OFF_THE_SHELVES');
      }
      return t('common.OUT_OF_STOCK');
    };
    const onConfirm = () => {
      isShowVal.value = false;
      emit('confirm');
    };
    return (_ctx, _cache) => {
      const _component_pop_up = _resolveComponent("pop-up");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createBlock(_component_pop_up, {
        show: isShowVal.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => isShowVal.value = $event),
        btnConfirmText: _unref(t)('button.KNOW'),
        isManualClose: "",
        title: _unref(t)('common.PRODUCTS_HAVE_BEEN_SOLD_OUT'),
        onConfirm: onConfirm,
        onClosed: onConfirm
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.asinList, item => {
          return _openBlock(), _createElementBlock("div", {
            class: "asin-image-content-item",
            key: item.mainImage
          }, [_withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [[_directive_lazy, item.productItem.mainImage]]), _createElementVNode("div", _hoisted_3, _toDisplayString(productStatusText(item.productItem.selectionEligible)), 1)]);
        }), 128))])]),
        _: 1
      }, 8, ["show", "btnConfirmText", "title"]);
    };
  }
};